export default function () {
  return {
    developments: [],
    developmentSearchResults: [],
    plans: [], // for the currently viewed Development
    planCategories: [], // the categories for the available plans
    lastDrawing: null // last opened site plan
  }
}
